"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizEvaluator = void 0;
class QuizEvaluator {
    async evaluate(submission, activity) {
        const config = activity.config;
        const questions = config.questions ?? [];
        const structuredData = (submission.structuredData ?? {});
        const answers = structuredData.answers ?? [];
        const totalQuestions = questions.length;
        const breakdown = questions.map((q) => {
            const answer = answers.find((a) => a.questionId === q.id);
            const isCorrect = answer ? answer.selectedOptionId === q.correctOptionId : false;
            return {
                name: q.text.slice(0, 40),
                score: isCorrect ? 1 : 0,
                maxScore: 1,
                feedback: isCorrect
                    ? q.feedback ?? 'Correct!'
                    : `Correct answer: ${q.options.find(o => o.id === q.correctOptionId)?.text ?? 'N/A'}`,
            };
        });
        const correctCount = breakdown.reduce((sum, c) => sum + c.score, 0);
        const maxScore = totalQuestions || 1;
        const percentage = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;
        return {
            score: percentage,
            maxScore: 100,
            isCorrect: correctCount === totalQuestions && totalQuestions > 0,
            feedback: correctCount === totalQuestions
                ? 'All answers correct!'
                : `${correctCount} of ${totalQuestions} correct`,
            breakdown,
            skills: [],
            label: 'Quiz Score',
        };
    }
}
exports.QuizEvaluator = QuizEvaluator;
